import CtrlTecnicoPage from './pages/CtrlTecnicoPage.vue'

const routes = [
  {
    path: 'ctrl-tecnicos',
    name: 'ctrl-tecnicos',
    component: CtrlTecnicoPage
  }
];

export default routes;